import { render, staticRenderFns } from "./recommend-new.vue?vue&type=template&id=7177dec0&scoped=true"
import script from "./recommend-new.vue?vue&type=script&lang=ts"
export * from "./recommend-new.vue?vue&type=script&lang=ts"
import style0 from "./recommend-new.vue?vue&type=style&index=0&id=7177dec0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7177dec0",
  null
  
)

/* custom blocks */
import block0 from "./recommend-new.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports